import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const getInfo = createAsyncThunk(
    "user/getInfo",
    async (token, thunkAPI) => {
        try {
            const res = await axios.get(
                `${BACKEND_URL}/userdetails`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            return res.data.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
        }
    }
);

const workerInfoSlice = createSlice({
    name: "workerInfo",
    initialState: {
        userData: [],
    },
    extraReducers: (builder) => {
        builder
            .addCase(getInfo.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getInfo.fulfilled, (state, action) => {
                state.loading = false;
                state.userData = action.payload.user;
            })
            .addCase(getInfo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default workerInfoSlice.reducer;
